import { DesktopModal } from '@byecode/ui'
import { WorkflowType } from '@lighthouse/shared'
import React, { useCallback } from 'react'
import styled from 'styled-components'
import { useImmer } from 'use-immer'

import { FlowDetailShape } from '@/contexts/FlowContext'
import type { WorkflowRunLog } from '@/services/types'

import { FlowLogDetail } from '../FlowDetail/FlowLogDetail'
import { FlowHistory } from '../FlowDetail/FlowModalManager/FlowHistory'

interface RunLogListProps {
    appId: string
}

interface RunLogListState {
    open: boolean
    data?: WorkflowRunLog
}

const SCxRunLogWrapper = styled.div`
    height: calc(100% - 100px);
`

export const RunLogList: React.FC<RunLogListProps> = () => {
    const [state, setState] = useImmer<RunLogListState>({
        open: false
    })
    const { open, data } = state

    const handleRowClick = useCallback(
        (val: WorkflowRunLog) => {
            setState({
                open: true,
                data: val
            })
        },
        [setState]
    )

    return (
        <SCxRunLogWrapper>
            <FlowHistory onRowClick={handleRowClick} />
            <DesktopModal
                open={open}
                withCloseIcon={false}
                styles={{
                    modal: {
                        width: '95vw',
                        height: '90vh'
                    },
                    body: {
                        padding: 0
                    }
                }}
                onClose={() => setState({ open: false })}
            >
                {data && (
                    <FlowLogDetail
                        id={data.workflowInstanceId}
                        name={data.name}
                        type={WorkflowType.AUTOMATION}
                        shape={FlowDetailShape.LOG_MODAL}
                        onClose={() => setState({ open: false })}
                        onBack={() => setState({ open: false })}
                    />
                )}
            </DesktopModal>
        </SCxRunLogWrapper>
    )
}
